// @flow
import styled from "styled-components";

export const StatsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	justify-content: flex-start;
	align-items: flex-start;
`;

export default StatsWrapper;